<!-- @format -->

<member-edit-modal>
  <div class="modal js-modal" is="modal-base" is-open="{ props.isOpen }">
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner" if="{ props.member.user_info }">
        <h2 class="heading-01 heading_search">メンバーの削除</h2>

        <p class="notice align-c">
          <strong>下記のメンバーの削除を実行します。</strong>
        </p>

        <div class="container_user-account">
          <div class="user-account_name">
            <div class="user-account_name-icon">
              <img
                if="{ props.member.user_info.icon_path }"
                src="{ props.member.user_info.icon_path }"
                alt=""
              />
              <img
                if="{ !props.member.user_info.icon_path }"
                src="/assets/img/icon_default.svg"
                alt=""
              />
            </div>
            <p class="user">{ props.member.name }</p>
            <p class="user-account_role">
              { Role.get(props.member.role).name} /
              {props.member.user_info.group_name}
            </p>
          </div>
        </div>
        <!--/.container_user-account-->

        <p class="notice">
          ※稼働中の注文がある場合は担当者は強制的に「管理者」の権限のメンバーに変更されます（「管理者」が複数いる場合は、一番最初に「管理者」に設定されたメンバーに変更されます。
        </p>
        <p class="notice">
          ※過去の注文情報の担当者は「退会済みメンバー」と表示されます。
        </p>
        <p class="notice">
          ※法人メンバーの中に必ず「管理者」のメンバーが1名必要です。メンバーの中に「管理者」がいなくなる状態での削除はできませんので、予め他メンバーの権限を「管理者」に変更したうえでメンバー削除を実施してください。
        </p>
        <p class="notice">
          ※一度メンバーの削除をすると取り消しや復旧などはできず、改めてメンバー紹介をして初期状態でのご利用となります。
        </p>

        <div class="container_button">
          <button
            class="button button-clear js-modal-close"
            type="button"
            onclick="{ props.onClose }"
          >
            キャンセル
          </button>
          <button
            class="button button-primary button-primary-mini"
            type="button"
            onclick="{ e => props.onDelete(e, props.member) }"
          >
            メンバーの削除
          </button>
        </div>
        <!--/.container_button-->
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import Role from "@model/role.js";
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
      onBeforeMount(props, state) {
        this.Role = Role;
      },
    };
  </script>
</member-edit-modal>
